import { render, staticRenderFns } from "./ListaEmails.vue?vue&type=template&id=89a63e16&scoped=true"
import script from "./ListaEmails.vue?vue&type=script&lang=js"
export * from "./ListaEmails.vue?vue&type=script&lang=js"
import style0 from "./ListaEmails.vue?vue&type=style&index=0&id=89a63e16&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a63e16",
  null
  
)

export default component.exports